(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/taggedTemplateLiteralLoose', 'react', 'react-emotion'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/taggedTemplateLiteralLoose'), require('react'), require('react-emotion'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.taggedTemplateLiteralLoose, global.react, global.reactEmotion);
    global.FullSpread = mod.exports;
  }
})(this, function (exports, _taggedTemplateLiteralLoose2, _react, _reactEmotion) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _taggedTemplateLiteralLoose3 = _interopRequireDefault(_taggedTemplateLiteralLoose2);

  var _react2 = _interopRequireDefault(_react);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _templateObject = (0, _taggedTemplateLiteralLoose3.default)(['\n    display: flex;\n    min-height: calc(100vh - 83px);\n    flex-flow: column nowrap;\n    @media (max-width: 768px) {\n      min-height: 100vh;\n    }\n  '], ['\n    display: flex;\n    min-height: calc(100vh - 83px);\n    flex-flow: column nowrap;\n    @media (max-width: 768px) {\n      min-height: 100vh;\n    }\n  ']);

  var Column = function Column(_ref) {
    var children = _ref.children;
    return _react2.default.createElement(
      'div',
      { className: (0, _reactEmotion.cx)('container-fluid', styles.div) },
      _react2.default.createElement(
        'div',
        { className: 'row', style: { flex: 1 } },
        children
      )
    );
  };

  var styles = {
    div: (0, _reactEmotion.css)(_templateObject)
  };

  exports.default = Column;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/layout/FullSpread.js
// module id = 757
// module chunks = 1